var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Slot } from "@/utils/types/layout";
import { WidgetTopic } from "@/utils/types/widgets";
import { useAppDispatch, useAppSelector } from "@/hooks/store";
import { addWidget as layoutAddWidget, clearWidgets as layoutClearWidgets, moveWidgetDown as layoutMoveWidgetDown, moveWidgetFirst as layoutMoveWidgetFirst, moveWidgetLast as layoutMoveWidgetLast, moveWidgetUp as layoutMoveWidgetUp, removeWidget as layoutRemoveWidget, setWidget as layoutSetWidget, updateWidget as layoutUpdateWidget, } from "@/store/layoutSlice";
import { ulid } from "ulidx";
import { useLogger } from "@/utils/loggerService";
import { useEvents } from "@/hooks/events";
/**
 * ETCRM Layout hook
 */
export function useLayout() {
    var _this = this;
    var dispatch = useAppDispatch();
    var events = useEvents().eventBus;
    var logger = useLogger().logger;
    var slots = useAppSelector(function (state) { return state.layout.slots; });
    var addWidget = function (_a) {
        var id = _a.id, actionUrl = _a.actionUrl, module = _a.module, type = _a.type, _b = _a.slot, slot = _b === void 0 ? Slot.MAIN : _b, _c = _a.pinned, pinned = _c === void 0 ? false : _c, _d = _a.order, order = _d === void 0 ? 0 : _d, _e = _a.payload, payload = _e === void 0 ? {} : _e;
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_f) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var widgetId = id || ulid();
                        var subscriptionId = events.once("".concat(WidgetTopic.WIDGET_CREATED, "/").concat(widgetId), function (data, topic) {
                            logger.debug("[USE LAYOUT] - EVT_BUS - Widget created");
                            events.off(subscriptionId);
                            resolve(data);
                        });
                        dispatch(layoutAddWidget({
                            id: widgetId,
                            actionUrl: actionUrl,
                            module: module,
                            widget: { type: type, payload: payload },
                            slot: slot,
                            pinned: pinned,
                            order: order,
                        }));
                    })];
            });
        });
    };
    var updateWidget = function (_a) {
        var id = _a.id, actionUrl = _a.actionUrl, module = _a.module, type = _a.type, _b = _a.slot, slot = _b === void 0 ? Slot.MAIN : _b, _c = _a.pinned, pinned = _c === void 0 ? undefined : _c, _d = _a.order, order = _d === void 0 ? 0 : _d, widget = _a.widget;
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_e) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var payload = dispatch(layoutUpdateWidget({
                            id: id,
                            actionUrl: actionUrl,
                            module: module,
                            type: type,
                            slot: slot,
                            pinned: pinned,
                            order: order,
                            widget: widget,
                        })).payload;
                        resolve(payload);
                    })];
            });
        });
    };
    var findWidgets = function (_a) {
        var id = _a.id, type = _a.type, _b = _a.slot, slot = _b === void 0 ? Slot.MAIN : _b;
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (!id) {
                            logger.warn("[LAYOUT] - L'identifiant du widget est requis");
                            reject(null);
                        }
                        if (!Array.isArray(slot) && !Object.hasOwn(slots, slot)) {
                            logger.warn("[LAYOUT] - Slot inconu: ".concat(slot, ". Le widget sera recherch\u00E9 dans \"main\""));
                            slot = Slot.MAIN;
                        }
                        var searchSlots = Array.isArray(slot)
                            ? slot
                            : [slot];
                        var widgets = searchSlots.reduce(function (acc, slot) {
                            var slotWidgets = slots[slot].widgets;
                            return __spreadArray(__spreadArray([], acc, true), slotWidgets.filter(function (w) {
                                return id && w.id === id && (type ? w.type === type : true);
                            }), true);
                        }, []);
                        resolve(widgets);
                    })];
            });
        });
    };
    var removeWidget = function (_a) {
        var id = _a.id, type = _a.type, _b = _a.slot, slot = _b === void 0 ? Slot.MAIN : _b;
        return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_c) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var payload, widgets;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    payload = dispatch(layoutRemoveWidget({ id: id, type: type, slot: slot })).payload;
                                    return [4 /*yield*/, findWidgets({ id: id, type: type, slot: slot })];
                                case 1:
                                    widgets = _a.sent();
                                    widgets.forEach(function (widget) {
                                        events.trigger(WidgetTopic.WIDGET_CLOSED, widget);
                                        events.trigger("".concat(WidgetTopic.WIDGET_CLOSED, "/").concat(widget.id), widget);
                                    });
                                    resolve(payload);
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    var removeWidgetById = function (params) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, removeWidget(params)];
    }); }); };
    var removeWidgetByType = function (params) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, removeWidget(params)];
    }); }); };
    var setWidget = function (_a) {
        var id = _a.id, actionUrl = _a.actionUrl, module = _a.module, type = _a.type, _b = _a.slot, slot = _b === void 0 ? Slot.MAIN : _b, _c = _a.pinned, pinned = _c === void 0 ? false : _c, _d = _a.order, order = _d === void 0 ? 0 : _d, _e = _a.payload, payload = _e === void 0 ? {} : _e;
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_f) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var widgetId = id || ulid();
                        var subscriptionId = events.once("".concat(WidgetTopic.WIDGET_CREATED, "/").concat(widgetId), function (data, topic) {
                            logger.debug("[USE LAYOUT] - Widget created");
                            events.off(subscriptionId);
                            resolve(data);
                        });
                        dispatch(layoutSetWidget({
                            id: widgetId,
                            actionUrl: actionUrl,
                            module: module,
                            type: type,
                            slot: slot,
                            pinned: pinned,
                            order: order,
                            widget: { type: type, payload: payload },
                        }));
                    })];
            });
        });
    };
    var clearWidgets = function (params) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var payload = dispatch(layoutClearWidgets(params)).payload;
                    resolve(payload);
                })];
        });
    }); };
    var moveWidgetFirst = function (params) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var payload = dispatch(layoutMoveWidgetFirst(params)).payload;
                    resolve(payload);
                })];
        });
    }); };
    var moveWidgetLast = function (params) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var payload = dispatch(layoutMoveWidgetLast(params)).payload;
                    resolve(payload);
                })];
        });
    }); };
    var moveWidgetUp = function (params) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var payload = dispatch(layoutMoveWidgetUp(params)).payload;
                    resolve(payload);
                })];
        });
    }); };
    var moveWidgetDown = function (params) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var payload = dispatch(layoutMoveWidgetDown(params)).payload;
                    resolve(payload);
                })];
        });
    }); };
    return {
        findWidgets: findWidgets,
        addWidget: addWidget,
        updateWidget: updateWidget,
        removeWidget: removeWidget,
        removeWidgetById: removeWidgetById,
        removeWidgetByType: removeWidgetByType,
        setWidget: setWidget,
        clearWidgets: clearWidgets,
        moveWidgetFirst: moveWidgetFirst,
        moveWidgetLast: moveWidgetLast,
        moveWidgetUp: moveWidgetUp,
        moveWidgetDown: moveWidgetDown,
    };
}
